// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/booking-link-logs/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/booking-link-logs/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Booking Link Logs" })
  return <Page />
}
